import PropTypes from "prop-types";

/**
 * PropTypes for PageTransitionOverlay component.
 *
 * @property {boolean} [active] - Whether the overlay should be visible
 */
export const pageTransitionOverlayPropTypes = {
  active: PropTypes.bool,
};
